import { useQuery } from '@tanstack/react-query'

import { getOnboardingRequestById } from '@src/api'
import { DefaultApiGetOnboardingRequestByIdRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchOnboardingRequestById = (
  params: DefaultApiGetOnboardingRequestByIdRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.onboardingRequestId,
    queryFn: () => getOnboardingRequestById(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_ZEUS_ONBOARDING_REQUESTS, params],
  })
}
